/// <reference types="vite/client" />

declare global {
  interface Window {
    __debug?: boolean;
  }
}

const params = new URLSearchParams(window.location.search);
const enabled =
  window.__debug === true ||
  params.get('debug') === '1' ||
  import.meta.env.DEV === true;

export function debugLog(...args: unknown[]): void {
  if (!enabled) return;
  // eslint-disable-next-line no-console
  console.log(...args);
}
export function warn(...args: unknown[]): void {
  // eslint-disable-next-line no-console
  console.warn(...args);
}
export function error(...args: unknown[]): void {
  // eslint-disable-next-line no-console
  console.error(...args);
}

export {};
